"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Wrapper = exports.HighlightWrapper = exports.AppointWrapper = exports.BaseWrapper = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var BaseWrapper = _styledComponents["default"].div.withConfig({
  displayName: "TrafficBaseCardStyles2__BaseWrapper",
  componentId: "t4qj34-0"
})(["width:", ";height:", ";overflow:hidden;position:relative;", ""], function (_ref) {
  var width = _ref.width;
  return width || '100%';
}, function (_ref2) {
  var height = _ref2.height;
  return height || '100%';
}, function (_ref3) {
  var isBeginEnd = _ref3.isBeginEnd,
      isHighlighted = _ref3.isHighlighted;
  return isBeginEnd ? "background: ".concat(isHighlighted ? '#394a6c' : '#1d2638', ";") : '';
});

exports.BaseWrapper = BaseWrapper;

var AppointWrapper = _styledComponents["default"].div.withConfig({
  displayName: "TrafficBaseCardStyles2__AppointWrapper",
  componentId: "t4qj34-1"
})(["", ""], function (_ref4) {
  var isAppointment = _ref4.isAppointment,
      isHighlighted = _ref4.isHighlighted,
      isBegin = _ref4.isBegin,
      isEnd = _ref4.isEnd,
      isError = _ref4.isError;
  return isAppointment && "\n      height: 100%;\n      background: ".concat(isHighlighted ? '#5181af' : '#3C648A', ";\n      border: ").concat(isError ? '0.15rem' : '0.05rem', " ").concat(isError ? 'red' : '#51AFEC', " solid;\n      box-sizing: border-box;\n      ").concat(isBegin && !isEnd ? "\n          border-radius: 15px 0 0 15px;\n        " : isError ? '' : 'border-left: 0;', "\n      ").concat(isEnd && !isBegin ? "\n          border-radius: 0 15px 15px 0;\n        " : isError ? '' : 'border-right: 0;', "\n      ").concat(isBegin && isEnd ? "border-radius: 15px 15px 15px 15px;" : '', "\n    ");
});

exports.AppointWrapper = AppointWrapper;

var HighlightWrapper = _styledComponents["default"].div.withConfig({
  displayName: "TrafficBaseCardStyles2__HighlightWrapper",
  componentId: "t4qj34-2"
})(["", ""], function (_ref5) {
  var isAppointment = _ref5.isAppointment,
      highlightBegin = _ref5.highlightBegin,
      highlightEnd = _ref5.highlightEnd,
      isBegin = _ref5.isBegin,
      isEnd = _ref5.isEnd;
  return isAppointment && highlightBegin !== highlightEnd && "\n      ".concat(highlightBegin && !highlightEnd ? "\n            border-radius: 15px 0 0 15px;\n            background: ".concat(isEnd ? '#1d2638' : '#3C648A', ";\n          ") : "\n            border-radius: 0 15px 15px 0;\n            background: ".concat(isBegin ? '#1d2638' : '#3C648A', ";\n          "), "\n    ");
});

exports.HighlightWrapper = HighlightWrapper;

var Wrapper = _styledComponents["default"].div.withConfig({
  displayName: "TrafficBaseCardStyles2__Wrapper",
  componentId: "t4qj34-3"
})(["box-sizing:border-box;height:100%;opacity:", ";background:", ";color:", ";", " ", " ", ";", " border-right:", ";border-left:", ";"], function (_ref6) {
  var searched = _ref6.searched;
  return searched === false ? '0.5' : '1';
}, function (_ref7) {
  var color = _ref7.color;
  return color || '#08C281';
}, function (_ref8) {
  var textColor = _ref8.textColor;
  return textColor || 'white';
}, function (_ref9) {
  var conflict = _ref9.conflict,
      color = _ref9.color;
  return conflict && "\n    background: ".concat(color || '#F12A1C', ";\n  ");
}, function (_ref10) {
  var free = _ref10.free,
      unused = _ref10.unused,
      isOverFree = _ref10.isOverFree,
      isBegin = _ref10.isBegin,
      isEnd = _ref10.isEnd,
      isHighlighted = _ref10.isHighlighted;
  return free && "\n      // border-radius: 0.2rem;\n      background: ".concat(isHighlighted ? '#5181af' : '#3C648A', " ", ";\n      // margin-right: 0.2rem;\n      border: 0.05rem ").concat(unused ? '#51AFEC' : isOverFree ? 'orange' : '#51AFEC', " solid;\n      ").concat(!isOverFree && "border-right: 0.05rem #51AFEC dashed;\n        border-left: 0.05rem #51AFEC dashed;", "\n      ").concat(isBegin && !isEnd ? "border-right: 0.05rem #51AFEC dashed;\n          border-radius: 15px 0 0 15px;\n          // background: #3d4f70;\n          border-left: 0.05rem #51AFEC solid !important;" : '', "\n      ").concat(isEnd && !isBegin ? "border-left: 0.05rem #51afeccc dashed;\n          border-radius: 0 15px 15px 0;\n          // background: #3d4f70;\n          border-right: 0.05rem #51AFEC solid !important;" : '', "\n      ").concat(isEnd && isBegin ? "border-radius: 15px 15px 15px 15px;\n          // background: #3d4f70;\n          border: 0.05rem #51AFEC solid !important;" : '', "\n    ");
}, function (_ref11) {
  var close = _ref11.close,
      isHighlighted = _ref11.isHighlighted;
  return close && "\n    // border-radius: 0.2rem;\n    // border: 0.05rem #51AFEC solid;\n    border: none;\n    border-right: 0.05rem #51afeccc dashed;\n    border-left: 0.05rem #51afeccc dashed;\n    // background: linear-gradient(to top right,\n    //   #1D2638 0%,\n    //   #1D2638 calc(50% - 0.15rem),\n    //   rgba(0,0,0,1) 50%,\n    //   #1D2638 calc(50% + 0.15rem),\n    //   #1D2638 100%);\n    background: ".concat(isHighlighted ? '#394a6c' : '#1d2638', ";\n  ");
}, function (_ref12) {
  var isAppointment = _ref12.isAppointment;
  return isAppointment ? 'border-radius: 15px;' : '';
}, function (_ref13) {
  var end = _ref13.end;
  return end % 100 ? 'none' : '';
}, function (_ref14) {
  var begin = _ref14.begin;
  return begin % 100 ? 'none' : '';
});

exports.Wrapper = Wrapper;